import { API_URL } from "@/config/urls";

// Admins use production caches in two ways:
// 1. accessing via insight.memcachier.com
// 2. using the production api url locally
export function isAdminUsingProd() {
  /*
  if 1. or 2.

  Used to disallow the following unsafe actions:
    flushCache
    rotateSSO
    switchCluster
    settings/addCredentials
    settings/removeCredentials
    settings/promoteCredentials
    settings/setCredentialsCapabilities
    alerts/add
    alerts/update
    alerts/remove
    debug-mode/addPrefix
    debug-mode/removePrefix
  */
  return (
    window.location.host.indexOf("insight.memcachier.com") >= 0 ||
    (process.env.NODE_ENV === "development" && API_URL.indexOf("insight.memcachier.com") >= 0)
  );
}

export function adminConsoleNotice() {
  if (isAdminUsingProd()) {
    // eslint-disable-next-line no-console
    console.log(
      "%cMC Insight",
      "color: #fff; background: #78bb13; border-radius: 1px; padding: 1px 2px",
      "You appear to be an admin using a production cache, unsafe actions will be disallowed.",
    );
  }
}
